<template>
    <search-summary-layout
        :search-disabled="searchDisabled"
        :search-request="searchRequest"
        :form-component="searchFormComponent"
        tourists-label="guest"
        show-dates
        show-tourists
    >
        <template v-slot:title>
            {{ locationLabel }}
        </template>
    </search-summary-layout>
</template>

<script lang="ts">
    import {Component, Prop, Vue} from 'vue-facing-decorator'
    import SearchSummaryLayout from '~src/components/parts/searchSummaryLayout.src'
    import SimpleTourSearchForm from '~src/components/simpleTours/search/forms/SimpleTourSearchForm.vue'

    //TODO Hide if empty searchRequest
    @Component({
        components: {
            SearchSummaryLayout,
            SimpleTourSearchForm,
        },
    })
    export class SimpleTourSearchSummary extends Vue {
        @Prop({default: false, type: Boolean}) searchDisabled
        @Prop({required: true}) searchRequest

        get searchFormComponent() {
            return resolveComponent('SimpleTourSearchForm')
        }

        get locationLabel() {
            if (this.$conf.public.searchWithoutDestination) {
                return `${simpleTourRuntimeStore.country.name}`
            }

            return `${simpleTourRuntimeStore.city.name}, ${simpleTourRuntimeStore.city.parentName}`
        }
    }

    export default SimpleTourSearchSummary
</script>
